import React, { Component } from 'react'
import { object, func } from 'prop-types'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import './Login.scss'

import Facebook from '../AppFooter/assets/facebook.svg'
import Facebooka from '../AppFooter/assets/facebook-a.svg'
import Twitter from '../AppFooter/assets/twitter.svg'
import Twittera from '../AppFooter/assets/twitter-a.svg'
import Gplus from './assets/google-plus.svg'
import Gplusa from './assets/google-plus-a.svg'

import { TextField } from '../Fields'

import { doLogin } from '../../modules/User'
import { changePopup } from '../../modules/Main'

class Login extends Component {
  static defaultProps = {
    user: { errorLogin: '', loginRequest: false },
    closePortal: () => {},
  }

  static propTypes = {
    doLogin: func.isRequired,
    changePopup: func.isRequired,
    closePortal: func,
    user: object,
  }

  state = {
    fields: {
      email: '',
      password: '',
    },
    error: {},
  }

  onChangeValidate = (name, values) => {
    const err = this.validate(name, values)
    if (err !== null) {
      this.setState({
        error: ({ ...this.state.error, ...{ [`${name}`]: err } }),
      })
    } else {
      const error = this.state.error
      delete error[`${name}`]
      this.setState({
        error,
      })
    }
  }

  handleOnFieldFocus = (e) => {
    const error = this.state.error
    if (error[`${e.target.name}`]) {
      delete error[`${e.target.name}`]
    }
    this.setState({
      error,
    })
  }

  handleOnFieldBlur = (e) => {
    this.onChangeValidate(e.target.name, e.target.value)
  }

  handleOnFieldChange = (e) => {
    const name = e.target.name
    const vals = e.target.value
    this.setState({
      fields: ({ ...this.state.fields, ...{ [`${name}`]: vals } }),
    }, () => {
      // this.onChangeValidate(name, vals)
    })
  }

  validate = (fields, values) => {
    let err = null
    if (fields === 'email') {
      if (values === '') {
        err = 'Email tidak boleh kosong'
      }
      if (!values.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        err = 'Email tidak sesuai format'
      }
    }

    if (fields === 'password') {
      if (values === '') {
        err = 'Password tidak boleh kosong'
      }

      if (values.length < 4) {
        err = 'Password minimal 4 karakter'
      }
    }
    return err
  }

  handleLogin = () => {
    if (Object.keys(this.state.error).length === 0 && this.state.error.constructor === Object) {
      const tifOptions = Object.keys(this.state.fields).map((key) => {
        const err = this.validate(key, this.state.fields[`${key}`])
        if (err !== null) {
          this.setState({
            error: ({ ...this.state.error, ...{ [`${key}`]: err } }),
          })
          return false
        }
        return true
      })

      const filtered = tifOptions.filter(x => x === false)
      if (filtered.length === 0) {
        const variables = {
          email: this.state.fields.email,
          password: this.state.fields.password,
        }
        this.props.doLogin(variables)
      }
    }
  }

  clearState = () => {
    this.setState({
      fields: {
        email: '',
        password: '',
      },
      error: {},
    })
  }

  render() {
    const { user } = this.props
    return (
      <div className='login__wrapper clearfix'>
        <h2>Masuk ke Minapoli</h2>
        { user.errorLogin !== '' && <div className='alert alert-danger'>{user.errorLogin}</div>}
        <div className='login__form'>
          <TextField
            label={'Email'}
            name={'email'}
            type={'email'}
            error={this.state.error.email}
            handleOnFieldFocus={this.handleOnFieldFocus}
            handleOnFieldChange={this.handleOnFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            value={this.state.fields.email}
            tabIndex={0} />

          <TextField
            label={'Password'}
            name={'password'}
            type={'password'}
            error={this.state.error.password}
            handleOnFieldFocus={this.handleOnFieldFocus}
            handleOnFieldChange={this.handleOnFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            value={this.state.fields.password}
            tabIndex={0} />
          <div className='row'>
            <div className='rl-cl-l-12 text-right'>
              <Link to='/' className='forgot__password' tabIndex='-1'>Lupa password?</Link>
            </div>
          </div>

          {/* <Link to='/' className='sms__login' tabIndex='-1'>Masuk dengan nomor telfon</Link> */}
          <div className='row'>
            <div className='rl-cl-l-6 clearfix'>
              <button
                type='button'
                disabled={user.loginRequest ? 'disabled' : ''}
                className='login__button'
                onClick={this.handleLogin}>Masuk</button>
            </div>
            <div className='rl-cl-l-6 clearfix'>
              <button
                type='button'
                onClick={() => { this.props.changePopup('register') }}
                className='register__button' >
              Daftar Gratis</button>
            </div>
          </div>
        </div>
        <div className='social__login clearfix'>
          <p>Atau masuk dengan :</p>
          <ul className='list-unstyled list-inline'>
            <li>
              <a href='https://api.minapoli.com/api/v1/auth/facebook'>
                <img src={Facebook} alt='' />
                <div className='hover'><img src={Facebooka} alt='' /></div>
              </a>
            </li>
            <li>
              <a href='https://api.minapoli.com/api/v1/auth/google'>
                <img src={Gplus} alt='' />
                <div className='hover'><img src={Gplusa} alt='' /></div>
              </a>
            </li>
            <li>
              <a href='https://api.minapoli.com/api/v1/auth/twitter'>
                <img src={Twitter} alt='' />
                <div className='hover'><img src={Twittera} alt='' /></div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  doLogin,
  changePopup,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login)



// WEBPACK FOOTER //
// ./src/common/Auth/Login.js